;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();import React from 'react';

import { graphRequest } from 'services/contentful';

import {
    assetFragment,
    ctaFragment,
    linkFragment,
} from 'lib/graphql/fragments';

import BlockTestimonialCarousel from './BlockTestimonialCarousel';

const query = /* GraphQL */ `
    ${assetFragment}
    ${ctaFragment}
    ${linkFragment}
    query getBlock($id: String!, $preview: Boolean!) {
        blockTestimonialCarousel(preview: $preview, id: $id) {
            __typename
            headline
            cta {
                ...CTA
            }
            icon {
                ...Asset
            }
            backgroundColor
            flushTop
            flushBottom
            slidesCollection(limit: 20) {
                items {
                    sys {
                        id
                    }
                    name
                    state
                    testimonial {
                        json
                    }
                }
            }
        }
    }
`;

async function fetchBlock(id) {
    const {
        body: {
            data: { blockTestimonialCarousel },
        },
    } = await graphRequest({
        query,
        variables: { id },
    });
    return blockTestimonialCarousel;
}

const BlockTestimonialCarouselServer = async ({ id, ...rest }) => {
    const block = await fetchBlock(id);
    const { slidesCollection, ...blockRest } = block;
    const slides = slidesCollection?.items?.filter(Boolean) ?? [];

    return (
        <BlockTestimonialCarousel {...blockRest} slides={slides} {...rest} />
    );
};

export default BlockTestimonialCarouselServer;
